import React from "react";
import { setSetting } from "../../../utils/frontendSettingsManager";
import { StyledSwitchWrapper } from "../../masterBalances/styledMasterBalances";
import MaterialSwitch from "../../styles/materialSwitch";

const HideSomeInfo = ({ data, setData, name, label }) => {
  const handleChangeSetting = (event) => {
    let value = event.target.checked;

    setSetting(name, value);
    setData(value);
  };

  return (
    <StyledSwitchWrapper>
      <div>
        {label ?? "Hide some info"}
      </div>
      <MaterialSwitch
        checked={data}
        onChange={handleChangeSetting}
        name={label ?? "Hide some info"}
      />
    </StyledSwitchWrapper>
  );
};

export default HideSomeInfo;